const ButtonPaymentReceived = (props: any) => (
    <button {...props}
        style={{
            cursor: props?.disabled ? 'not-allowed' : 'pointer',
            backgroundColor: props?.disabled ? 'gray' : 'green',
            borderRadius: 50,
            color: 'white',
            width: 80,
            height: 28,
            fontSize: 14,
            fontWeight: 'normal',
        }}
    >
        Received
    </button>
);

export default ButtonPaymentReceived;